import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { Card } from '@ergeon/core-components';

type PanelProps = {
  children: ReactNode;
  className?: string;
  meta?: ReactNode;
  title: string;
  titleId: string;
};

const Panel = ({ children, className, meta, title, titleId }: PanelProps) => (
  <Card aria-labelledby={titleId} className={classNames('flex-col', className)} rounded="medium" tag="section">
    <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <h2 className="paragraph-2 font-semibold text-gray-900 dark:text-white" id={titleId}>{title}</h2>
      {meta && <p className="paragraph-3 text-gray-600 dark:text-gray-400">{meta}</p>}
    </div>
    {children}
  </Card>
);

export default Panel;
